export default __webpack_public_path__ + "static/media/Dryer.0efa2d65.png";